const toSnakeCase = (str: string) => str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z][0-9]+|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('_');

const toKebabCase = (str: string) => str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z][0-9]+|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('-');

const toPascalCase = (str: string) => str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z][0-9]+|[A-Z]|[0-9]+/g)
    .map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
    .join('');

const toCamelCase = (str: string) => {
  const s = str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
      .join('');
  return s.slice(0, 1).toLowerCase() + s.slice(1);
};

const toText = (v: unknown) => {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  if (Array.isArray(v)) {
    return v
      .filter((x): x is string | number | boolean => ['string','number','boolean'].includes(typeof x))
      .map(String)
      .join(', ');
  }
  try { return JSON.stringify(v); } catch { return ''; }
};

const stringUtil = {
  toSnakeCase,
  toKebabCase,
  toPascalCase,
  toCamelCase,
  toText
};

export default stringUtil;
